import styled from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import ResponsiveImage from '../image/responsive';
import CTA from '../cta';

export const Card = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxshadow.small};
  flex: 0 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  position: relative;

  ${breakpoint.mobileLand`
    flex: 0 49%;  
  `};

  &:hover {
    box-shadow: ${({ theme }) => theme.boxshadow.standard};

    > a {
      background-color: ${({ theme }) => theme.palette.primaryLinkHover};
    }
  }
`;

export const Thumbnail = styled(ResponsiveImage)`
  width: 100%;
  height: auto;
  min-height: 1px;
  border-radius: ${({ theme }) => theme.borderradius.small}
    ${({ theme }) => theme.borderradius.small} 0;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const StyledCardInfoList = styled.ul`
  padding: 0;
  list-style: none;
  margin-bottom: 0;

  li:not(:last-of-type) {
    margin-bottom: ${({ theme }) => theme.spacing.small};
  }
`;

export const CardContent = styled.div`
  width: 100%;
  padding: 0 ${({ theme }) => theme.spacing.standard}
    ${({ theme }) => theme.spacing.standard};
  flex: 3;
  display: table-cell;
`;

export const StyledCTA = styled(CTA)`
  margin: auto ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.small};
`;

export const CardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
